/**
=========================================================
* Soft UI Dashboard PRO React - v3.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// @mui material components
import Link from "@mui/material/Link";
import Icon from "@mui/material/Icon";

// Soft UI Dashboard PRO React components
import SuiBox from "components/SuiBox";
import SuiTypography from "components/SuiTypography";

// Soft UI Dashboard PRO React base styles
import typography from "assets/theme/base/typography";
import { externalLinks } from "utils/data";

function Footer({ company, color }) {
  const { size } = typography;

  return (
    <SuiBox
      width="100%"
      display="flex"
      flexDirection={{ xs: "column", lg: "row" }}
      justifyContent="space-between"
      alignItems="center"
      px={1.5}
      py={2}
    >
      <SuiBox
        display="flex"
        justifyContent="center"
        alignItems="center"
        flexWrap="wrap"
        color="text"
        fontSize={size.sm}
        gap={1}
        px={1.5}
      >
        {" "}
        <SuiBox color={color}>
          &copy; {new Date().getFullYear()} UpStyled Fashion. All rights reserved{" "}
        </SuiBox>
        |
        <SuiBox
          color={color}
          component="a"
          href={externalLinks["terms-of-service"]}
          target="_blank"
        >
          Terms and Conditions of Use
        </SuiBox>
        |
        <SuiBox color={color} component="a" href={externalLinks["privacy-policy"]} target="_blank">
          Privacy Policy
        </SuiBox>
        |
        <SuiBox color={color} component="a" href={externalLinks["help"]} target="_blank">
          Help Center
        </SuiBox>
        |
        <SuiBox color={color} component="a" href={"/contactus"}>
          Contact Us
        </SuiBox>
        |
        <SuiBox color={color} component="a" href={externalLinks["about-us"]} target="_blank">
          About Us
        </SuiBox>
      </SuiBox>
    </SuiBox>
  );
}

// Setting default values for the props of Footer
Footer.defaultProps = {
  company: { href: "https://www.upstyled.co/", name: "UpStyled Fashion" },
  color: "secondary",
};

// Typechecking props for the Footer
Footer.propTypes = {
  company: PropTypes.objectOf(PropTypes.string),
  color: PropTypes.string,
};

export default Footer;
